module.exports = "/packs/images/products/membership-814fc7440e951e4a5e36f185aea098a4.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/membership.png
// module id = 1798
// module chunks = 0